// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.common-modal-content {
  background: white;
  z-index: 10000;
  padding: 2rem;
  border-radius: 10px;
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  max-width: 800px;
}

.common-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
}

.close-cross {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.client-common-modal-footer {
  margin-top: 1rem;
  text-align: right;
}

.invoice-export-modal {
  padding: 1rem 1.5rem;
}
.invoice-export-modal h3 {
  font-size: 1.6rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.3rem;
  text-align: center;
}
.invoice-export-modal .export-subtext {
  font-size: 0.95rem;
  color: #6b7280;
  text-align: center;
  margin-bottom: 1.5rem;
}
.invoice-export-modal .export-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
}
.invoice-export-modal .export-options .export-option-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 18px;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 500;
  color: #1f2937;
  background-color: #f3f4f6;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.25s ease;
}
.invoice-export-modal .export-options .export-option-btn .export-icon {
  font-size: 1.1rem;
}
.invoice-export-modal .export-options .export-option-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.invoice-export-modal .export-options .export-option-btn:active {
  transform: scale(0.98);
}
.invoice-export-modal .export-options .export-option-btn.pending {
  background-color: #fef9c3;
  color: #92400e;
  border: 1px solid #fde68a;
}
.invoice-export-modal .export-options .export-option-btn.paid {
  background-color: #d1fae5;
  color: #065f46;
  border: 1px solid #6ee7b7;
}
.invoice-export-modal .export-options .export-option-btn.part-payment {
  background-color: #dbeafe;
  color: #1e40af;
  border: 1px solid #93c5fd;
}
.invoice-export-modal .export-options .export-option-btn.all {
  background-color: #e5e7eb;
  color: #374151;
  border: 1px solid #d1d5db;
}

.exp-service-modal-body h3 {
  font-size: 1.2rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
}
.exp-service-modal-body .new-service-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  box-sizing: border-box;
}
.exp-service-modal-body .new-service-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.exp-service-modal-body .submit-btn-common-modal {
  width: 100%;
  padding: 0.8rem;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.exp-service-modal-body .submit-btn-common-modal:hover {
  box-shadow: 0 8px 25px rgba(59, 130, 246, 0.4);
  background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
}
.exp-service-modal-body .submit-btn-common-modal:hover::before {
  left: 100%;
}
.exp-service-modal-body .submit-btn-common-modal:active {
  transform: translateY(0);
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);
}
.exp-service-modal-body .submit-btn-common-modal:disabled {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 8px rgba(156, 163, 175, 0.2);
}
.exp-service-modal-body .submit-btn-common-modal:disabled::before {
  display: none;
}
.exp-service-modal-body .submit-btn-common-modal:disabled:hover {
  transform: none;
  box-shadow: 0 2px 8px rgba(156, 163, 175, 0.2);
}
.exp-service-modal-body .submit-btn-common-modal.loading {
  position: relative;
  color: transparent;
}
.exp-service-modal-body .submit-btn-common-modal.loading::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  margin: -10px 0 0 -10px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.client-modal-header .close-cross {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
}
.client-modal-header .close-cross:hover {
  color: #374151;
  background-color: #f3f4f6;
}

@media (max-width: 768px) {
  .exp-service-modal-body {
    padding: 2rem 1.5rem 1.5rem;
  }
  .exp-service-modal-body h3 {
    font-size: 1.5rem;
    margin-bottom: 0.75rem;
  }
  .exp-service-modal-body::before {
    font-size: 0.8rem;
    margin-bottom: 1.25rem;
  }
  .exp-service-modal-body .new-service-input {
    padding: 0.875rem 1rem;
    margin-bottom: 1.5rem;
    font-size: 0.95rem;
  }
  .exp-service-modal-body .submit-btn-common-modal {
    padding: 0.875rem 1.25rem;
    font-size: 0.95rem;
  }
}
@media (max-width: 480px) {
  .exp-service-modal-body {
    padding: 1.5rem 1rem 1rem;
  }
  .exp-service-modal-body h3 {
    font-size: 1.25rem;
    padding-right: 1.5rem;
  }
  .exp-service-modal-body::before {
    font-size: 0.75rem;
    margin-bottom: 1rem;
  }
}
@keyframes slideInScale {
  0% {
    opacity: 0;
    transform: translateY(-20px) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.exp-service-modal-body .new-service-input:focus-visible,
.exp-service-modal-body .submit-btn-common-modal:focus-visible {
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/CommonModal/CommonModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EAEA,gBAAA;AAAF;;AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;AAAF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AACF;;AACA;EACE,gBAAA;EACA,iBAAA;AAEF;;AAAA;EACE,oBAAA;AAGF;AADE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;AAGJ;AAAE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AAEJ;AACA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,6BAAA;EACA,eAAA;EACA,0BAAA;AACJ;AACI;EACE,iBAAA;AACN;AAEI;EACE,2BAAA;EACA,yCAAA;AAAN;AAGI;EACE,sBAAA;AADN;AAII;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAFN;AAKI;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAHN;AAMI;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAJN;AAOI;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AALN;;AAsBE;EAYE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA9BJ;AA4CE;EA4BE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AArEJ;AAuEI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AArEN;AAyEE;EACE,WAAA;EACA,eAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;EACA,yBAAA;EACA,qBAAA;AAvEJ;AA0FI;EAEE,8CAAA;EACA,6DAAA;AAzFN;AA2FM;EACE,UAAA;AAzFR;AA6FI;EACE,wBAAA;EACA,8CAAA;AA3FN;AA8FI;EACE,6DAAA;EACA,mBAAA;EACA,eAAA;EACA,8CAAA;AA5FN;AA8FM;EACE,aAAA;AA5FR;AA+FM;EACE,eAAA;EACA,8CAAA;AA7FR;AAkGI;EACE,kBAAA;EACA,kBAAA;AAhGN;AAkGM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,iCAAA;EACA,kBAAA;EACA,kCAAA;AAhGR;;AAuGA;EAyBE,gBAAA;EACE,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AA5HJ;AA8HI;EACE,cAAA;EACA,yBAAA;AA5HN;;AAsIA;EACE;IACE,2BAAA;EAnIF;EAqIE;IACE,iBAAA;IACA,sBAAA;EAnIJ;EAsIE;IACE,iBAAA;IACA,sBAAA;EApIJ;EAuIE;IACE,sBAAA;IACA,qBAAA;IACA,kBAAA;EArIJ;EAwIE;IACE,yBAAA;IACA,kBAAA;EAtIJ;AACF;AA0IA;EACE;IACE,yBAAA;EAxIF;EA0IE;IACE,kBAAA;IACA,qBAAA;EAxIJ;EA2IE;IACE,kBAAA;IACA,mBAAA;EAzIJ;AACF;AA8IA;EACE;IACE,UAAA;IACA,uCAAA;EA5IF;EA8IA;IACE,UAAA;IACA,iCAAA;EA5IF;AACF;AA+IA;EACE;IACE,uBAAA;EA7IF;EA+IA;IACE,yBAAA;EA7IF;AACF;AAkJE;;EAGE,mBAAA;AAjJJ","sourcesContent":[".common-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.common-modal-content {\n  background: white;\n  z-index: 10000;\n  padding: 2rem;\n  border-radius: 10px;\n  position: relative;\n  max-height: 90vh;\n  overflow-y: auto;\n  // width: 90%;\n  max-width: 800px;\n}\n\n.common-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background: rgba(0,0,0,0.4);\n}\n.close-cross {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n}\n.client-common-modal-footer {\n  margin-top: 1rem;\n  text-align: right;\n}\n.invoice-export-modal {\n  padding: 1rem 1.5rem;\n\n  h3 {\n    font-size: 1.6rem;\n    font-weight: 600;\n    color: #1f2937;\n    margin-bottom: 0.3rem;\n    text-align: center;\n  }\n\n  .export-subtext {\n    font-size: 0.95rem;\n    color: #6b7280;\n    text-align: center;\n    margin-bottom: 1.5rem;\n  }\n\n.export-options {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1rem;\n\n  .export-option-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 12px 18px;\n    border-radius: 10px;\n    font-size: 0.95rem;\n    font-weight: 500;\n    color: #1f2937;\n    background-color: #f3f4f6;\n    border: 1px solid transparent;\n    cursor: pointer;\n    transition: all 0.25s ease;\n\n    .export-icon {\n      font-size: 1.1rem;\n    }\n\n    &:hover {\n      transform: translateY(-1px);\n      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n    }\n\n    &:active {\n      transform: scale(0.98);\n    }\n\n    &.pending {\n      background-color: #fef9c3;\n      color: #92400e;\n      border: 1px solid #fde68a;\n    }\n\n    &.paid {\n      background-color: #d1fae5;\n      color: #065f46;\n      border: 1px solid #6ee7b7;\n    }\n\n    &.part-payment {\n      background-color: #dbeafe;\n      color: #1e40af;\n      border: 1px solid #93c5fd;\n    }\n\n    &.all {\n      background-color: #e5e7eb;\n      color: #374151;\n      border: 1px solid #d1d5db;\n    }\n  }\n}\n\n}\n\n\n// Service Modal SCSS - Modern styling for expense form modals\n\n.exp-service-modal-body {\n  // padding: 1.5rem;\n  // // background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);\n  // background-color: #f8fafc;\n  // border-radius: 16px;\n  // position: relative;\n  \n  h3 {\n    // font-size: 1.5rem;\n    // font-weight: 700;\n    // color: #1f2937;\n    // margin-bottom: 1rem;\n    // text-align: center;\n    // // padding-right: 2rem;\n    // background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n    // -webkit-background-clip: text;\n    // -webkit-text-fill-color: transparent;\n    // background-clip: text;\n    // letter-spacing: -0.025em;\n    font-size: 1.2rem;\n    font-weight: 500;\n    color: #374151;\n    margin: 0 0 1rem 0;\n  }\n\n  // Subtitle for better UX\n  // &::before {\n  //   content: \"Enter the new field name below\";\n  //   display: block;\n  //   font-size: 0.875rem;\n  //   color: #6b7280;\n  //   text-align: center;\n  //   margin-bottom: 1.5rem;\n  //   font-style: italic;\n  // }\n\n  .new-service-input {\n    // width: 100%;\n    // padding: 1rem 1.25rem;\n    // border: 2px solid #e5e7eb;\n    // border-radius: 12px;\n    // font-size: 1rem;\n    // color: #374151;\n    // background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);\n    // transition: all 0.3s ease;\n    // margin-bottom: 2rem;\n    // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    \n    // &:focus {\n    //   outline: none;\n    //   // border: none;\n    //   background: #ffffff;\n    //   transform: translateY(-1px);\n    // }\n\n    // &::placeholder {\n    //   color: #9ca3af;\n    //   // font-style: italic;\n    // }\n\n    // &:hover {\n    //   border-color: #d1d5db;\n    //   // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    // }\n    width: 100%;\n    padding: 0.5rem;\n    border: 1px solid #d1d5db;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n    margin-bottom: 1rem;\n    box-sizing: border-box;\n\n    &:focus {\n      outline: none;\n      border-color: #3b82f6;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n  }\n\n  .submit-btn-common-modal {\n    width: 100%;\n    padding: 0.8rem;\n    background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n    color: white;\n    border: none;\n    border-radius: 12px;\n    font-size: 0.9rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n    box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n\n    // Shine effect\n    // &::before {\n    //   content: '';\n    //   position: absolute;\n    //   top: 0;\n    //   left: -100%;\n    //   width: 100%;\n    //   height: 100%;\n    //   background: linear-gradient(\n    //     90deg, \n    //     transparent, \n    //     rgba(255, 255, 255, 0.3), \n    //     transparent\n    //   );\n    //   transition: left 0.6s ease;\n    // }\n\n    &:hover {\n      // transform: translateY(-2px);\n      box-shadow: 0 8px 25px rgba(59, 130, 246, 0.4);\n      background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n      \n      &::before {\n        left: 100%;\n      }\n    }\n\n    &:active {\n      transform: translateY(0);\n      box-shadow: 0 4px 14px rgba(59, 130, 246, 0.3);\n    }\n\n    &:disabled {\n      background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);\n      cursor: not-allowed;\n      transform: none;\n      box-shadow: 0 2px 8px rgba(156, 163, 175, 0.2);\n\n      &::before {\n        display: none;\n      }\n\n      &:hover {\n        transform: none;\n        box-shadow: 0 2px 8px rgba(156, 163, 175, 0.2);\n      }\n    }\n\n    // Loading state\n    &.loading {\n      position: relative;\n      color: transparent;\n\n      &::after {\n        content: '';\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        width: 20px;\n        height: 20px;\n        margin: -10px 0 0 -10px;\n        border: 2px solid #ffffff;\n        border-top: 2px solid transparent;\n        border-radius: 50%;\n        animation: spin 1s linear infinite;\n      }\n    }\n  }\n}\n\n// Enhanced close button for service modal\n.client-modal-header .close-cross {\n  // top: 0.3rem;\n  // right: 0.3rem;\n  // width: 36px;\n  // height: 36px;\n  // display: flex;\n  // align-items: center;\n  // justify-content: center;\n  // border-radius: 50%;\n  // background: rgba(239, 68, 68, 0.1);\n  // color: #ef4444;\n  // font-size: 18px;\n  // font-weight: 600;\n  // transition: all 0.2s ease;\n  // z-index: 10;\n\n  // &:hover {\n  //   background: rgba(239, 68, 68, 0.2);\n  //   transform: scale(1.1) rotate(90deg);\n  //   color: #dc2626;\n  // }\n\n  // &:active {\n  //   transform: scale(0.95) rotate(90deg);\n  // }\n  background: none;\n    border: none;\n    font-size: 1.5rem;\n    color: #6b7280;\n    cursor: pointer;\n    padding: 0;\n    width: 2rem;\n    height: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0.25rem;\n\n    &:hover {\n      color: #374151;\n      background-color: #f3f4f6;\n    }\n}\n\n// Animation for modal entrance\n.exp-service-modal-body {\n  //animation: slideInScale 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  .exp-service-modal-body {\n    padding: 2rem 1.5rem 1.5rem;\n    \n    h3 {\n      font-size: 1.5rem;\n      margin-bottom: 0.75rem;\n    }\n\n    &::before {\n      font-size: 0.8rem;\n      margin-bottom: 1.25rem;\n    }\n\n    .new-service-input {\n      padding: 0.875rem 1rem;\n      margin-bottom: 1.5rem;\n      font-size: 0.95rem;\n    }\n\n    .submit-btn-common-modal {\n      padding: 0.875rem 1.25rem;\n      font-size: 0.95rem;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .exp-service-modal-body {\n    padding: 1.5rem 1rem 1rem;\n    \n    h3 {\n      font-size: 1.25rem;\n      padding-right: 1.5rem;\n    }\n\n    &::before {\n      font-size: 0.75rem;\n      margin-bottom: 1rem;\n    }\n  }\n}\n\n// Keyframe animations\n@keyframes slideInScale {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.9);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n// Focus states for accessibility\n.exp-service-modal-body {\n  .new-service-input:focus-visible,\n  .submit-btn-common-modal:focus-visible {\n    // outline: 2px solid #3b82f6;\n    outline-offset: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
